// Text colour that stays legible on a coloured pill or banner.
//
// The contract pages paint their status banner (and a few chips) in fixed colours with white text.
// White reads fine on the reds and greys, but on the light fills — the "Qisman" yellow #d8d813,
// the "To'liq" green #26d317, the dark theme's yellow primary — it drops to about 1.5:1 to 2:1 and
// the text all but disappears. A fill at least as light as those gets dark text instead.

export const DARK_TEXT = "#111318";
export const LIGHT_TEXT = "#ffffff";

// WCAG relative luminance above which a fill counts as light. The yellow is 0.64 and the green
// 0.47; the reds (about 0.21) and the grey #616161 (0.12) stay below it and keep white text.
const LIGHT_FILL = 0.4;

export function readableTextOn(color) {
  const rgb = parseColor(color);
  if (!rgb) return LIGHT_TEXT;
  return luminance(rgb) > LIGHT_FILL ? DARK_TEXT : LIGHT_TEXT;
}

function parseColor(color) {
  if (typeof color !== "string") return null;
  const c = color.trim();
  let m = c.match(/^#([0-9a-f]{3})$/i);
  if (m) return m[1].split("").map((h) => parseInt(h + h, 16));
  m = c.match(/^#([0-9a-f]{6})$/i);
  if (m) return [0, 2, 4].map((i) => parseInt(m[1].substr(i, 2), 16));
  m = c.match(/^rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/i);
  if (m) return [m[1], m[2], m[3]].map(Number);
  return null;
}

function luminance([r, g, b]) {
  const lin = (v) => {
    const s = v / 255;
    return s <= 0.03928 ? s / 12.92 : Math.pow((s + 0.055) / 1.055, 2.4);
  };
  return 0.2126 * lin(r) + 0.7152 * lin(g) + 0.0722 * lin(b);
}
